/* eslint max-classes-per-file: 0 */

import {
  UserActionCollection as Data,
  UserActionCollection as Collection,
} from '@/typings/api/User'
import { UsersActionsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class UsersActionsTransformerParams extends TransformerParams {
  protected defaultParams = ['user_id'];
}

export class UsersActionsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new UsersActionsTransformerParams();
}
